import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

import { alert } from "./alert.module";
import { authentication } from "./authentication.module";
import { companies } from "./companies.module";
import { currencies } from "./currencies.module";
import { commodities } from "./commodities.module";
import { countries } from "./countries.module";
import { etfs } from "./etfs.module";
import { futures } from "./futures.module";
import { indexes } from "./index.module";
import { intRates } from "./intRates.module";
import { user_preferences } from "./user_preferences.module";
import { currencies_intraday_history } from "./currencies_intraday_history.module";
import { total_currency_exposure } from "./total_currency_exposure.module";
import { user } from "./user.module";
import { user_routes } from "./user_routes.module";

Vue.use(Vuex);

const vuexStorage = new VuexPersist({
  key: "sourcelink",
  storage: window.localStorage,
  // You can change this explicitly use
  // either window.localStorage  or window.sessionStorage
  // However we are going to make use of localForage
});

export const store = new Vuex.Store({
  plugins: [vuexStorage.plugin],
  modules: {
    alert,
    authentication,
    commodities,
    companies,
    countries,
    currencies_intraday_history,
    currencies,
    etfs,
    futures,
    indexes,
    intRates,
    total_currency_exposure,
    user_preferences,
    user_routes,
    user,
  },
});
